// extracted by mini-css-extract-plugin
module.exports = {"navbarLogin":"NavbarLogin_navbarLogin__Qr2Cj"};